import React from 'react'
import { QuizCardSide } from './quizCardElement'
import { Box } from '@chakra-ui/react'

export function QuizCard({
  q,
  index,
  dispatch,
  status,
  offset,
  isLastCard,
  isCorrect,
}) {
  const commonProps = {
    data: q,
    index,
    status,
    offset,
  }
  return (
    <Box>
      <QuizCardSide
        type='question'
        onClick={(payload) => dispatch({ type: 'answer', payload })}
        {...commonProps}
      />
      <QuizCardSide
        type={'answer'}
        onClick={() => dispatch({ type: 'next' })}
        isCorrect={isCorrect}
        {...commonProps}
      />
    </Box>
  )
}
